export default __webpack_public_path__ + "media/stress-glp1-companion.69840ad62f7042f75ca5ae7b262990a0.webp";